// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"551":"0893f34e","842":"79a16a6b"}[chunkId] + ".chunk.js";
};